import React from 'react';
import BasicLayout from '../../layout/BasicLayout/BasicLayout';
import ImgCheck from '../../assets/img/check.png';
import './ExitoEnvio.scss';
import { Image, Button } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';

//redux
import { connect } from 'react-redux';
import { logout } from '../../_actions/usuarioActions';

const ExitoEnvio = props => {
  
  const history = useHistory()
  const params = useParams()
  const { url } = params

  const { logout } = props

  const logoutUser = () => {

    logout()
    history.push(`/form/${url}`)

  }
  
  return ( 
    <BasicLayout header={false}>
      <div className="exito-envio">
      <div className="main-mensaje shadow-sm bg-white">
        <div className="header-encuesta">
          <h1>ENVIADO</h1>
        </div>
        <div className="body-mensaje bg-white p-4">

          <div className="body-mensaje__mensaje">
              
              <div className="logo">
                  <Image src={ImgCheck}/>
                  <h5>Gracias</h5>
              </div>
             
              <p className='mt-5'>La respuesta se ha enviado</p>
{/* 
              <Button onClick={() => logoutUser()}>
                Salir
              </Button> */}
          </div>

        </div>
      </div>
      <div className="foot">© 2020 INEDI Posgrados &reg; Privacy & Cookies</div>
      </div>
    </BasicLayout>
   );
}

const mapStateToProps = state => ({

}) 

export default connect( mapStateToProps , { logout })(ExitoEnvio);